﻿import configuratorForm from '../modules/trellus-configurator/trellus-configurator-form.js';
import configuratorDatalayer from '../modules/datalayer/pages/trellus-configurator-datalayer.js';
import configuratorResizer from '../modules/configurator/configurator-resizer.js';

function initConfigurator() {
    if (configuratorForm.canInit('#trellus-configurator-form')) {
        configuratorForm.init();
    }

    if (configuratorForm.canInitForm('#trellus-configurator-form')) {
        configuratorForm.initForm();
    }

    configuratorResizer.init('#trellus-configurator-form');
    configuratorDatalayer.init('#configurator-container');
}

document.addEventListener('DOMContentLoaded', function () {
    initConfigurator();
});